import create from "zustand";

export const useStore = create((set, get) => ({
  searchResults: [],
  productGroups: [],
  fetchProducts: async (query, helpers) => {
    console.log(query, 'current query');
    try {
      const data = await fetch(`/api/products?q=${query.toLowerCase()}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          searchTerm: query.toLowerCase(),
        }),
      });
      
      
      const result = await data.json();

      set({
        searchResults: result.data,
      });

      if (helpers) {
        helpers.setLoading;
        helpers.setSearchValue;
      }
    } catch (error) {
      console.log("error on fetch data", error);
    }
  },
}));
